import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Skeleton,
  IconButton,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DeleteIcon from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useNavigate } from "react-router-dom";
import { vendorApi } from "../../api/api";
import { useSelector } from "react-redux";
const YourPropertyDocuments = ({ data }) => {
  const [allDocuments, setAllDocuments] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const theme = useSelector((data) => data.themeValue.colors);
  
  const typeMap = {
    1: "project",
    2: "property",
    3: "apartment",
    4: "individual villa"
  };
  useEffect(() => {
    if (!data) return;
    const payload = {
      propertyId: data[0]?.Pid ?? data[0]?.id ?? null,
      PropertyType: typeMap[data[0]?.type] ?? typeMap[data[0]?.PropertyType]
    };
    const fetchDocuments = async () => {
      const response = await vendorApi.getDocumentsById(payload);
      setAllDocuments(response.data);
    }
    fetchDocuments();
  }, [data]);
  const handleDelete = async(id) => {
     const confirmDelete = window.confirm("Are you sure you want to delete this document?");
     if (!confirmDelete) return;
     try {
      
       const response = await vendorApi.deleteDocumentById({
        id:id,
        type:data[0].type ??data[0]?.PropertyType
       });
       if (response.status === 200) {
         setAllDocuments((prevDocs) => prevDocs.filter((doc) => doc.id !== id));
         alert("Document deleted successfully");
       } else {
         alert("Failed to delete document");
       }
     } catch (error) {
       console.error("Error deleting document:", error);
       alert("Error occurred while deleting the document.");
     }
  };
  const openPdf = (url) => {
    window.open(url, "_blank");
  };
  return (
    <Box sx={{ mt:2, backgroundColor: theme.background, padding: "20px", borderRadius: "20px" ,pt:2 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom sx={{ color: theme.text }}>
        Property Documents
      </Typography>
      <Card variant="outlined" sx={{ borderRadius: 2, p: 2, backgroundColor: theme.background }}>
        <CardContent>
          {loading ? (
            <Stack spacing={2}>
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} variant="rounded" height={40} />
              ))}
            </Stack>
          ) : allDocuments.length > 0 ? (
            <>
              {(showAll ? allDocuments : allDocuments.slice(0, 3)).map((doc) => (
                <Box
                  key={doc.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1,
                    mb: 1,
                    borderRadius: 1,
                    border: `1px solid ${theme.borderColor}`,
                    backgroundColor: theme.background,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PictureAsPdfIcon sx={{ color: theme.normal_icon }} />
                    <Typography sx={{ color: theme.text }}>{doc.DocumentName
                    }</Typography>
                  </Box>
                  <Box>
                    <IconButton
                      onClick={() => openPdf(doc.DocumentURL)}
                      aria-label="view document"
                      size="small"
                      sx={{ color: theme.normal_icon }}
                    >
                      <OpenInNewIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDelete(doc.id)}
                      aria-label="delete document"
                      size="small"
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              ))}
              {allDocuments.length > 3 && (
                <Button
                  onClick={() => setShowAll(!showAll)}
                  size="small"
                  variant="outlined"
                  color="primary"
                  sx={{ mt: 2 }}
                >
                  {showAll ? "Show Less" : "View All Documents"}
                </Button>
              )}
            </>
          ) : (
            <Typography color="text.secondary">
              No Documents Available
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};
export default YourPropertyDocuments;









